import gql from 'graphql-tag';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { getAllListingsQuery } from '../../../lib/graphql';

const ADMIN_SET_FEATURED = gql`
  mutation adminSetFeatured($listId: Int!, $featured: Boolean!) {
    adminSetFeatured(listId: $listId, featured: $featured) {
      status
      errorMessage
    }
  }
`;

export const setListingFeatured = (listId, featured, currentPage, searchList) => {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation: ADMIN_SET_FEATURED,
        variables: { listId, featured },
        refetchQueries: [{ query: getAllListingsQuery, variables: { currentPage, searchList } }]
      });

      if (data?.adminSetFeatured?.status === 'success') {
        showToaster({ 
          messageId: featured ? 'addFeatured' : 'removeFeatured', 
          toasterType: 'success',
          requestMessage: featured ? 'Listing destacado exitosamente' : 'Destacado removido'
        });
        return { success: true };
      } else {
        showToaster({ 
          messageId: 'commonError', 
          toasterType: 'error', 
          requestMessage: data?.adminSetFeatured?.errorMessage || 'Error al actualizar'
        });
        return { success: false };
      }
    } catch (error) {
      console.error('setListingFeatured error:', error);
      showToaster({ 
        messageId: 'commonError', 
        toasterType: 'error', 
        requestMessage: error.message 
      });
      return { success: false };
    }
  };
};
